import { BUGSNAG_API_KEY } from '../../config';
const bugsnag = require('bugsnag-js');  // this is 4 years old, replace with @bugsnag/js
const bugsnagClient = bugsnag({
  apiKey: BUGSNAG_API_KEY,
  notifyReleaseStages: [ 'production', 'staging' ],
});
bugsnagClient.app.type = 'web'; // todo: this moves as appType into start({}}) on v 7+
bugsnagClient.setUser = (user) => {
  bugsnagClient.user = {
    id: user,
  };
};
bugsnagClient.debug = () => { /* no-op */ };

export const logger = bugsnagClient;
